
@if(from === 'profile'){
    <app-heading [breadcrumbTitleOptions]="breadcrumbTitleOptions" [title]="'Education'" [button]="headingButton" [isbreadcrumb]="true" [showToggle]="false"></app-heading>    
} @else{
    <div class="grid grid-nogutter mb-3">
        <div class="col-12 md:col-6 sm:col-12 sm:mb-2">
            <h1 class="h4 m-0">Education</h1>
            
        </div>
        <div class="col-12 md:col-6 sm:col-12 flex md:justify-content-end justify-content-between mt-3 md:mt-0 align-items-start sm:align-items-center  md:gap-4 gap-0 ">
            <p-button styleClass="vibrant-pink-background" label="add a degree" [rounded]="true" icon="pi pi-plus" size="large" (onClick)="showCreateSchool()"/>
        </div>
    </div>
    
}

<!-- No Data Education-->
@if(educationDataLength === 0){
    <div class="flex flex-column h-page-full">
        <div class="flex flex-column gap-1 h5 text-center">
            <span>Please enter any education and degree information you’d like to share with {{selectedTenant ? selectedTenant.firm.name : ''}}</span>
        </div>
    </div>
}

<!-- List/Edit Education-->
@if(educationDataLength > 0){
<p-accordion [multiple]="true" class="w-full">
    @for (education of educations; track education) {
        <p-accordionTab>
            <ng-template pTemplate="header">
                <span class="flex align-items-center gap-4 w-full">
                    <div class="flex flex-column line-height-2">
                        <span class="font-medium white-space-nowrap">
                            {{education.school.name}}
                        </span>
                        <span class="text-sm text-black-alpha-60">
                            {{education.degree.type}}
                        </span>
                    </div>
                    <div class="mx-auto ">
                        @if(status(education)){
                            <p-tag [value]="status(education)" [rounded]="true" />
                        }
                    </div>
                @if(!education.isLocked){
                    <div class="wrap-actions flex align-items-center">
                        <p-button (click)="navigateToEditScreen(education)"  [rounded]="true" [text]="true" icon="true">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                        </p-button>
                        <button pButton pRipple type="button" (click)="onDelete($event, education)" [rounded]="true" [text]="true" icon="true"
                            class="danger-icon">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                        </button>
                    </div>
                }
                </span>
            </ng-template>
            <div class="flex flex-column gap-3">
                <div class="grid">
                    <div class="col-6 lg:col-4 flex flex-column">
                        <span class="text-xs text-primary-900 font-medium">Institution</span>
                        <span class="text-black-alpha-60"> {{education.school.name}}</span>
                    </div>
                    <div class="col-6 lg:col-4 flex flex-column">
                        <span class="text-xs text-primary-900 font-medium">Degree</span>
                        <span class="text-black-alpha-60">{{education.degree.type}}</span>
                    </div>
                    <div class="col-6 lg:col-4 flex flex-column">
                        <span class="text-xs text-primary-900 font-medium">Major</span>
                        <span class="text-black-alpha-60">{{education.degree.major}}</span>
                    </div>
                    <div class="col-6 lg:col-4 flex flex-column">
                        <span class="text-xs text-primary-900 font-medium">{{'Timeline' | sentenceCase}}</span>
                        <span class="text-black-alpha-60">{{education.school.startDate | date:'yyyy'}} -- {{education.school.endDate | date:'yyyy'}}</span>
                    </div>
                </div>
            </div>
        </p-accordionTab>
    }
</p-accordion>
}

@if(from === 'onboarding'){
    <div class="flex gap-3 mt-3">
        <p-button
          label="back"
          rounded="true"
          outlined="true"
          (onClick)="submit('back')"
          size="large"
          styleClass="white-space-nowrap"
        ></p-button>
        <p-button
          label="next"
          rounded="true"
          size="large"
          [disabled]="educationDataLength === 0"
          styleClass="white-space-nowrap freshgreen-background"
          (onClick)="submit('next')"
        ></p-button>
        @if(isSkipButtonEnabled){
            <p-button
            label="skip onboarding"
            rounded="true"
            outlined="true"
            size="large"
            styleClass="white-space-nowrap"
            (onClick)="navigateToDashboard()"
            ></p-button>
        }
    </div>
} @else {
    <div class="flex gap-3 mt-3">
        <p-button label="back" rounded="true" outlined="true" size="large"
            styleClass="white-space-nowrap" (onClick)="onBack()"></p-button>
    </div> 
}

<!-- List/Edit Education End-->